import React, { FC, ReactNode } from 'react';
import { Box, Flex, FlexProps } from '@chakra-ui/react';

import ProgressBar from 'components/_core/ProgressBar';

interface Props {
  children: ReactNode;
  button: ReactNode;
  progress: number;
}

/**
 * Template for capital deposit questions page
 */
const CapitalDepositQuestionPage: FC<FlexProps & Props> = ({
  button,
  children,
  progress,
  ...rest
}) => {
  return (
    <Box paddingBottom="space-80" {...rest}>
      <Box>{children}</Box>

      {/* @todo find a better solution than position: fixed and hardcoded width
      maybe define a new zone in the layout ? */}

      <Box
        background={{
          base: 'linear-gradient(0deg, rgba(255,255,255,1) 0%, rgba(255,255,255,.85) 80%, rgba(255,255,255,1) 100%)',
          md: 'white',
        }}
        bottom="0"
        maxWidth="420px"
        paddingRight={{ base: 'space-32', md: '0' }}
        position="fixed"
        width={{ base: '100%', md: '420px' }}
      >
        <ProgressBar ratio={progress} />

        <Flex flexDirection="row-reverse" padding="space-16">
          {button}
        </Flex>
      </Box>
    </Box>
  );
};

export default CapitalDepositQuestionPage;
